<template>
    <div>
        <div class="buttons">
            <HomeButton icon="publish" title="Upload file" to="/upload"/>
            <HomeButton icon="admin_panel_settings" title="Your token" to="/token"/>
            <HomeButton icon="dns" title="Uploaded files" to="/files"/>
            <HomeButton icon="link" title="Shorted links" to="/links"/>
            <!--            <hr class="signOutHr">-->
            <!--            <HomeButton @click.prevent="signOut" icon="login" title="Sign out" to=""/>-->
        </div>


        <router-link :to="'/files/' + lastFile.fileId" class="last-file" v-if="lastFile">
            Recently uploaded: <u>{{lastFile.name}}</u>
        </router-link>
    </div>
</template>

<script>
    import * as firebase from 'firebase/app';
    import 'firebase/firestore';
    import {fadeOutPage, requireUser} from '../other/page-global';
    import HomeButton from '../components/HomeButton';

    export default {
        name: 'HomeLayout',
        components: {HomeButton},
        created() {
            requireUser(this).then(({uid}) => {
                this.unsub = firebase
                    .firestore()
                    .collection('last-uploaded')
                    .doc(uid)
                    .onSnapshot(this.lastUploadedFileChanged);
            });
        },
        destroyed() {
            if (this.unsub)
                this.unsub();
        },
        methods: {
            lastUploadedFileChanged(file) {
                this.lastFile = file.data();
            },
            signOut() {
                if (confirm('Are you sure you want to sign out?'))
                    fadeOutPage().then(() => {
                        firebase.auth().signOut();
                        this.$router.push({path: '/login'});
                    });
            },
        },
        data() {
            return {
                lastFile: null
            };
        }
    };
</script>

<style scoped>


    .buttons {
        display: block;
        padding: 4px;
    }

    @media (min-height: 450px) {
        .buttons {
            display: grid;
            grid-gap: 10px;
            grid-template-columns: 1fr 1fr;
        }

        .signOutHr {
            display: none;
        }
    }

    .last-file {
        padding: 12px;
        display: inline-block;
        animation: FadeIn .4s;
        border-radius: 4px;
        background-color: #0c0c2a;
        opacity: .83;
        text-decoration: none;
        color: white;
    }
</style>
